// Email-Service mit Web3Forms + Supabase Speicherung
import { supabase } from './supabaseClient';

const EMAIL_CONFIG = [

  {
    email: 'svanselemajeri@norsjo.nu',
    apiKey: 'ea357f9f-c98e-4de5-a2b5-b032e4c92576'
  }
];

export const sendEmail = async (formData) => {
  try {
    // 1. In Supabase speichern
    if (formData.formType === 'contact') {
      const { error } = await supabase
        .from('contact_submissions')
        .insert([
          {
            name: formData.name,
            email: formData.email,
            subject: formData.subject,
            message: formData.message
          }
        ]);
      
      if (error) {
        console.error('Supabase error:', error);
        // Weiter mit E-Mail-Versand, auch wenn Speicherung fehlschlägt
      }
    } else if (formData.formType === 'wholesale') {
      const { error } = await supabase
        .from('wholesale_submissions')
        .insert([
          {
            name: formData.name,
            email: formData.email,
            business_type: formData.businessType || formData.type,
            request_type: formData.want,
            products: formData.products || [],
            delivery_date: formData.day || null,
            message: formData.message
          }
        ]);
      
      if (error) {
        console.error('Supabase error:', error);
        // Weiter mit E-Mail-Versand, auch wenn Speicherung fehlschlägt
      }
    }

    // 2. E-Mails über Web3Forms senden
    const emailPromises = EMAIL_CONFIG.map(async (config) => {
      const formDataToSend = new FormData();
      formDataToSend.append('access_key', config.apiKey);
      formDataToSend.append('name', formData.name);
      formDataToSend.append('email', formData.email);
      
      if (formData.formType === 'contact') {
        formDataToSend.append('subject', formData.subject);
        formDataToSend.append('message', formData.message);
      } else if (formData.formType === 'wholesale') {
        const productsList = formData.productsLabels && formData.productsLabels.length > 0 
          ? formData.productsLabels.join(', ') 
          : 'Keine Produkte ausgewählt';
        
        formDataToSend.append('subject', 'Großhandelsanfrage');
        formDataToSend.append('Unternehmenstyp', formData.businessTypeLabel || formData.businessType || formData.type);
        formDataToSend.append('Anfrage-Typ', formData.wantLabel || formData.want);
        formDataToSend.append('Lieferdatum', formData.day || 'Nicht angegeben');
        formDataToSend.append('Produkte', productsList);
        formDataToSend.append('Nachricht', formData.message);
      }

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataToSend
      });

      const data = await response.json();
      
      if (!response.ok || !data.success) {
        throw new Error(data.message || 'Fehler beim Versenden');
      }

      return { success: true, email: config.email };
    });

    await Promise.all(emailPromises);
    return { success: true, message: 'E-Mail erfolgreich versendet und gespeichert' };
  } catch (error) {
    console.error('Email error:', error);
    throw new Error('Fehler: ' + error.message);
  }
};
